module.exports = __webpack_public_path__ + "img/image.a88cd37e.png";